import { __rest } from "tslib";
import React from 'react';
import { Modal as AntModal } from 'antd';
import clsx from 'clsx';
import { PrimaryButton } from '../Button';
import { CrossIcon } from '../../assets/svgs';
import useModalTitle from './useModalTitle';
import useRectifyModalFocus from './useRectifyModalFocus';
import './Modal.less';
const DEFAULT_MODAL_WIDTH_IN_PIXELS = 500;
/**
 * KDS-compliant Modal component based on Ant Design Modal.
 */
export default function Modal(props) {
    const { title, className, footer, variant = 'simple', width = DEFAULT_MODAL_WIDTH_IN_PIXELS, contentFlexHeight, headerIcon, children } = props, otherProps = __rest(props, ["title", "className", "footer", "variant", "width", "contentFlexHeight", "headerIcon", "children"]);
    const actualFooter = footer || React.createElement(PrimaryButton, { onClick: props.onClose }, "Close");
    useRectifyModalFocus(otherProps.visible);
    return (React.createElement(AntModal, Object.assign({ title: useModalTitle(title, headerIcon), className: clsx('kal-modal', `variant-${variant}`, contentFlexHeight && 'force-flex-height', headerIcon && 'with-header-icon', !title && 'no-header', className), closeIcon: React.createElement(CrossIcon, null), footer: actualFooter, width: width }, otherProps), children));
}
//# sourceMappingURL=Modal.js.map